import {
  Component,
  ElementRef,
  OnInit,
  signal,
} from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { empty } from "../../functions";
import { CompanyService } from "../../shared/services/company.service";
import {
  faMapMarkerAlt,
  faSearch,
  faLink,
  faUnlink,
  faEdit,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faGoogle,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { jobpostingTypes, JobService } from "../../shared/services/job.service";
import { Observable, of, Subscription } from "rxjs";
import { VideoService } from "../../shared/services/video.service";
import { catchError } from "rxjs/operators";
import {
  companyprofilePlaceholder,
  ModelCompanyprofile,
} from "../../model/model.companyprofile";
import { UserService } from "../../shared/services/user.service";
import { RoleTypes } from "../../guards/roletypes";
import { InterestService } from "../../shared/services/interest.service";
import { LocaleService } from "../../shared/services/locale.service";
import { ModalService } from "../../shared/services/modal.service";
import {
  alertMessages,
  AlertService,
} from "../../shared/services/alert.service";
import {
  ExperiencedayService,
  experiencedayStatuses,
} from "../../shared/services/experienceday.service";
import { MatchService } from "../../shared/services/match.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalCompanyApplyComponent } from "../modal-company-apply/modal-company-apply.component";

@Component({
  selector: "app-company-profile-public",
  templateUrl: "./company-profile-public.component.html",
  styleUrls: ["./company-profile-public.component.scss"],
  standalone: false,
})
export class CompanyProfilePublicComponent implements OnInit {
  activeTab = 'story';
  public companyReadMore: any = {
    NL: false,
    EN: false,
    DE: false,
    FR: false,
    PT: false,
  };

  isLoading = signal(false);
  isProcessing = false;

  avatarPlaceholder = companyprofilePlaceholder.avatarPlaceholder;

  RoleTypes = RoleTypes;

  faSearch = faSearch;
  faMapMarkerAlt = faMapMarkerAlt;
  faFacebookF = faFacebookF;
  faInstagram = faInstagram;
  faLinkedinIn = faLinkedinIn;
  faXTwitter = faXTwitter;
  faGoogle = faGoogle;
  faLink = faLink;
  faUnlink = faUnlink;
  faEdit = faEdit;
  faPaperPlane = faPaperPlane;

  public entity: ModelCompanyprofile | any = {
    id: "",
    status: "",
    name: "",
    registrationNumber: "",
    visitAddress: {
      street: "",
      number: "",
      numberSuffix: "",
      city: "",
      postalCode: "",
      country: "",
    },
    phoneNumber: "",
    address_city: "",
    description: "",
    descriptionEn: "",
    descriptionDe: "",
    descriptionFr: "",
    descriptionPt: "",
    uniqueText: "",
    uniqueTextEn: "",
    uniqueTextDe: "",
    uniqueTextPt: "",
    opportunitiesText: "",
    opportunitiesTextEn: "",
    opportunitiesTextDe: "",
    opportunitiesTextFr: "",
    opportunitiesTextPt: "",
    sectorId: "",
    sectorName: "",
    numberOfEmployees: "",
    websiteUri: "",
    twitterUri: "",
    facebookUri: "",
    linkedInUri: "",
    instagramUri: "",
    googleUri: "",
    avatarUri: "",
    coverPhotoUri: "",
    currentUserMatchPercentage: 0,
    isCurrentUserFavorite: false,
    companyImageReferences: [],
    areaOfInterests: <any>[],
    primaryContact: {
      id: "",
      emailAddress: "",
      infix: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      avatarUri: "",
    },
    dataChallengeday: <any>{
      minAmountStudents: null,
      maxAmountStudents: null,
      foreignStudents: null,
      internships: null,
      programme: null,
      dates: <any>[],
    },
  };

  companyTrademarks: any = [];
  companyPhotos: any[] = [];
  companyVideos: any[] = [];

  public jobs = {
    filters: {
      search: "",
      types: <string[]>[],
    },
    data: <any>[],
    dataFiltered: <any>[],
  };

  public assignments = {
    filters: {
      search: "",
      types: <string[]>[],
    },
    data: <any>[],
    dataFiltered: <any>[],
  };

  public jobTypes: any = [];

  public formChallengeday = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    city: "",
    date: "",
  };

  areaOfInterests = [];

  storyLanguages: string[] = [];
  activeStoryLanguage = "NL";

  view = {
    experiencedays: {
      isLoading: false,
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      data: <any[]>[],
    },
  };

  /**
   * Constructor
   *
   * @param route
   * @param userService
   * @param interestService
   * @param companyService
   * @param jobService
   * @param videoService
   * @param locale
   * @param modal
   * @param experiencedayService
   * @param alertService
   */
  constructor(
    public route: ActivatedRoute,
    public userService: UserService,
    public interestService: InterestService,
    public companyService: CompanyService,
    public jobService: JobService,
    public videoService: VideoService,
    public locale: LocaleService,
    public modal: ModalService,
    public experiencedayService: ExperiencedayService,
    public alertService: AlertService,
    public match: MatchService,
    public el: ElementRef,
    private ngbModal: NgbModal
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.jobTypes = this.jobService.getTypes();

    // Load general collection data
    this.interestService
      .apiGetAreaOfInterests()
      .pipe(
        catchError(
          this.interestService.handleError("apiGetAreaOfInterests", false)
        )
      )
      .subscribe((result: any) => {
        if (result) {
          this.areaOfInterests = result.data;
        }
      });

    this.route.paramMap.subscribe((params: ParamMap) => {
      const id: string = <string>params.get("id");
      if (!empty(id)) {
        this.getData(id);
      }

      const tab: string = <string>params.get("tab");
      if (tab === "experienceday") {
        this.activeTab = "experienceday";
      }
    });
  }

  selectTab(tabId: string) {
    this.activeTab = tabId;
  }

  /**
   * Get profile data
   *
   * @param id
   */
  getData(id: string) {
    this.isLoading.set(true);

    this.companyService
      .apiGetCompanyProfile(id)
      .pipe(
        catchError(
          this.companyService.handleError("apiGetCompanyProfile", false)
        )
      )
      .subscribe((result: any) => {
        this.isLoading.set(false);
        if (result) {
          this.entity = Object.assign(<ModelCompanyprofile>{}, result);

          this.entity.dataChallengeday = {
            minAmountStudents: null,
            maxAmountStudents: null,
            foreignStudents: null,
            internships: null,
            programme: null,
            dates: <any>[],
          };

          // Parse image data for carousel
          this.companyVideos = [];
          this.companyPhotos = [];
          if (this.entity.companyImageReferences.length > 0) {
            this.entity.companyImageReferences.map((image: any) => {
              if (image.youtubeUri) {
                this.companyVideos.push({
                  youtubeUri: image.youtubeUri,
                  youtubeImageUri: this.videoService.getYoutubeThumbnail(
                    image.youtubeUri
                  ),
                });
              } else {
                if (image.imageUri) {
                  this.companyPhotos.push(image);
                }
              }
            });

            this.companyPhotos.reverse();
            this.companyVideos.reverse();
          }

          // Set available story languages to show
          if (this.entity.description) {
            this.storyLanguages.push("NL");
          }
          if (this.entity.descriptionEn) {
            this.storyLanguages.push("EN");
          }
          if (this.entity.descriptionDe) {
            this.storyLanguages.push("DE");
          }
          if (this.entity.descriptionFr) {
            this.storyLanguages.push("FR");
          }
          if (this.entity.descriptionPT) {
            this.storyLanguages.push("PT");
          }

          if (this.storyLanguages.length > 0) {
            const currentLanguage = this.locale.getCurrentLanguage();
            if (
              this.storyLanguages.indexOf(currentLanguage.toUpperCase()) !== -1
            ) {
              this.activeStoryLanguage = currentLanguage.toUpperCase();
            } else {
              this.activeStoryLanguage = this.storyLanguages[0];
            }
          }

          // Get all company job postings
          this.getCompanyJobPostings();

          // Get all trademarks of company
          this.getProfileTrademarks(id);

          // Get all experience days of company
          this.getCompanyExperiencedays(id);
        }
      });
  }

  /**
   * Get all trademarks of company profile
   *
   * @param profile_id
   */
  getProfileTrademarks(profile_id: string) {
    this.companyService.apiGetTrademarks(profile_id).subscribe((trademarks) => {
      if (trademarks) {
        this.companyTrademarks = Object.assign([], trademarks);
      } else {
        this.companyTrademarks = [];
      }
    });
  }

  /**
   * Get company jobs
   */
  getCompanyJobPostings() {
    // Fetch company job postings
    this.jobService
      .apiGetCompanyJobs(this.entity.id)
      .pipe(catchError(this.jobService.handleError("apiGetCompanyJobs", false)))
      .subscribe((result: any) => {
        if (result) {
          this.jobs.data = result.data;
          this.jobs.dataFiltered = result.data;

          let assignments = Object.assign([], result.data);
          assignments = assignments.filter(
            (item: any) => item["type"] == jobpostingTypes.Assignment
          );
          this.assignments.data = Object.assign([], assignments);
          this.assignments.dataFiltered = Object.assign([], assignments);

          this.jobs.dataFiltered = Object.assign(
            [],
            this.jobs.dataFiltered.filter(
              (item: any) => item["type"] != jobpostingTypes.Assignment
            )
          );
        }
      });
  }

  /**
   * Apply all filters on job postings of the company
   */
  applyFilterCompanyJobPostings() {
    const dataFiltered = <any>[];
    this.jobs.dataFiltered = [];

    if (this.jobs.data.length > 0) {
      for (const jobPosting of this.jobs.data) {
        let addJob = true;

        if (
          !empty(this.jobs.filters.search) &&
          jobPosting.title
            .toLowerCase()
            .indexOf(this.jobs.filters.search.toLowerCase()) === -1
        ) {
          addJob = false;
        }

        if (
          !empty(this.jobs.filters.types) &&
          !this.jobs.filters.types.includes(jobPosting.type)
        ) {
          addJob = false;
        }

        if (addJob) {
          dataFiltered.push(jobPosting);
        }
      }

      this.jobs.dataFiltered = Object.assign([], dataFiltered);
    }
  }

  /**
   * Check if job posting filter type value already is set
   * @param type
   */
  existJobpostingType(type: string) {
    return this.jobs.filters.types.includes(type);
  }

  /**
   * Toggle jobposting filter type value
   *
   * @param type
   */
  toggleJobpostingType(type: string) {
    let found: boolean | string = false;
    if (this.jobs.filters.types.length > 0) {
      for (const i in this.jobs.filters.types) {
        const value = this.jobs.filters.types[i];
        if (value == type) {
          found = i;
        }
      }

      if (found === false) {
        this.jobs.filters.types.push(type);
      } else {
        this.jobs.filters.types.splice(parseInt(found, 10), 1);
      }
    } else {
      this.jobs.filters.types.push(type);
    }

    this.applyFilterCompanyJobPostings();
  }

  /**
   * Apply all filters on job postings of the company
   */
  applyFilterCompanyAssignments() {
    const dataFiltered = <any>[];
    this.assignments.dataFiltered = [];

    if (this.assignments.data.length > 0) {
      for (const jobPosting of this.assignments.data) {
        let addJob = true;

        if (
          !empty(this.assignments.filters.search) &&
          jobPosting.title
            .toLowerCase()
            .indexOf(this.assignments.filters.search.toLowerCase()) === -1
        ) {
          addJob = false;
        }

        if (
          !empty(this.assignments.filters.types) &&
          !this.assignments.filters.types.includes(jobPosting.type)
        ) {
          addJob = false;
        }

        if (addJob) {
          dataFiltered.push(jobPosting);
        }
      }

      this.assignments.dataFiltered = Object.assign([], dataFiltered);
    }
  }

  /**
   * Add a company as favorite
   */
  addCompanyAsFavorite() {
    if (this.entity.id) {
      this.isProcessing = true;

      this.companyService
        .apiAddCompanyFavorite(this.entity.id)
        .pipe(
          catchError(
            this.companyService.handleError("apiAddCompanyFavorite", false)
          )
        )
        .subscribe((result) => {
          this.isProcessing = false;

          if (result !== false) {
            this.entity.isCurrentUserFavorite =
              !this.entity.isCurrentUserFavorite;
          }
        });
    }
  }

  /**
   * Delete a company as favorite
   */
  deleteCompanyAsFavorite() {
    if (this.entity.id) {
      this.isProcessing = true;
      this.companyService
        .apiDeleteCompanyFavorite(this.entity.id)
        .pipe(
          catchError(
            this.companyService.handleError("apiDeleteCompanyFavorite", false)
          )
        )
        .subscribe((result) => {
          this.isProcessing = false;

          if (result !== false) {
            this.entity.isCurrentUserFavorite =
              !this.entity.isCurrentUserFavorite;
          }
        });
    }
  }

  /**
   * Add a company as favorite
   */
  addCompanyConnection() {
    if (this.entity.id) {
      this.isProcessing = true;

      this.companyService
        .apiAddCompanyConnection(this.entity.id)
        .pipe(
          catchError(
            this.companyService.handleError("apiAddCompanyConnection", false)
          )
        )
        .subscribe((result) => {
          this.isProcessing = false;

          if (result !== false) {
            this.entity.isCurrentUserConnected =
              !this.entity.isCurrentUserConnected;
          }
        });
    }
  }

  /**
   * Delete a company as favorite
   */
  deleteCompanyConnection() {
    if (this.entity.id) {
      this.isProcessing = true;
      this.companyService
        .apiDeleteCompanyConnection(this.entity.id)
        .pipe(
          catchError(
            this.companyService.handleError("apiDeleteCompanyConnection", false)
          )
        )
        .subscribe((result) => {
          this.isProcessing = false;

          if (result !== false) {
            this.entity.isCurrentUserConnected =
              !this.entity.isCurrentUserConnected;
          }
        });
    }
  }

  /**
   * Get company experience days
   */
  getCompanyExperiencedays($companyId: string, $queryParams: any = null) {
    this.view.experiencedays.isLoading = true;

    // TODO: set maybe a company id filter
    this.experiencedayService
      .apiGetCompanyExperiencedays($companyId, $queryParams)
      .pipe(catchError(this.handleError("apiGetExperiencedays", false)))
      .subscribe((result: any) => {
        this.view.experiencedays.isLoading = false;

        if (result.data) {
          let tmp = Object.assign([], result.data);
          // Only get open for registration experience days for public view
          tmp = tmp.filter(
            (item: any) =>
              item["status"] == experiencedayStatuses.OpenForRegistration
          );
          this.view.experiencedays.data = tmp;
          this.view.experiencedays.totalItems = result.totalItems;
        }
      });
  }

  /**
   * Register an experience day date (planned experience day)
   *
   * @param $experienceday | model of experience day
   * @param $date | date string to register for
   */
  registerExperiencedayDate($experienceday: any, $date: string) {
    this.isProcessing = true;
    this.modal.Loader(true);

    if ($experienceday["isCurrentUserRegistered"]) return;

    this.experiencedayService
      .apiCreateExperiencedayDate($experienceday["id"], $date)
      .pipe(catchError(this.handleError("apiCreateExperiencedayDate", false)))
      .subscribe((response) => {
        this.isProcessing = false;
        this.modal.Loader(false);

        if (response !== false) {
          this.getCompanyExperiencedays(this.entity.id);
        }
      });
  }

  /**
   * Show trademark description in modal
   *
   * @param trademark
   */
  showTrademarkDescription(trademark: any) {
    this.modal.Alert(trademark.name, trademark.description);
  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation: string = "", result?: T) {
    return (error: any): Observable<T> => {
      // Handle given operation
      switch (operation) {
        case "apiGetCompanyCurrent":
          // Do not perform any action, profile could be non-existing
          break;

        case "apiUpdateCompanyprofile":
        default:
          this.alertService.errorWithReport(error, `companyProfilePublic:${operation}`);
          break;
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /**
   * Toggle company read more
   *
   * @param lang
   */
  toggleCompanyReadMore(lang: any) {
    this.companyReadMore[lang] = !this.companyReadMore[lang];
  }

  setActiveStoryLanguage($language: string) {
    this.activeStoryLanguage = $language;
  }

  /**
   * Open company application modal
   */
  openCompanyApplicationModal() {
    const modalRef = this.ngbModal.open(ModalCompanyApplyComponent, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.data = {
      company: {
        id: this.entity.id,
        name: this.entity.name,
      },
    };

    modalRef.result
      .then((result) => {
        if (result === true) {
          // Application was sent successfully
          // Could potentially refresh data or show additional feedback here
        }
      })
      .catch((error) => {
        // Modal was dismissed/cancelled
      });
  }
}
